import { Box, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { postMethodApi } from "../../Utils/Methods";
import { POST_ANNOUNCEMENT_TRACKER } from "../../Apis/EndPoints";
import { UseAuthContext } from "../../context/auth-context";

const dateAlpha = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TabsPanel({
  tabHeadings,
  tabData,
  isAnnouncmentEnable,
  setToggle,
  setLoginScreen,
}) {
  const [value, setValue] = useState(0);
  const [heading, setHeading] = useState(tabHeadings[0]);
  const email = localStorage.getItem("email");
  const { token } = UseAuthContext();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const announcementTrack = (title, id) => {
    if (token) {
      postMethodApi(POST_ANNOUNCEMENT_TRACKER, {
        userid: email,
        announcementtitle: title,
        announcementid: id,
      })
        .then((res) => {
          if (res.status === 201) {
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      setToggle(true);
      setLoginScreen(true);
    }
  };

  const dateFunction = (date) => {
    let dateArr = date.split("-");
    return `${dateAlpha[+dateArr[1] - 1]} ${dateArr[2]}, ${dateArr[0]}`;
  };

  return (
    <Box>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        aria-label="scrollable auto tabs example"
        className="homeTabs"
      >
        {tabHeadings?.map((ele, ind) => {
          return (
            <Tab
              className="tab"
              onClick={() => setHeading(ele)}
              key={ind}
              label={ele}
              {...a11yProps(ind)}
            />
          );
        })}
      </Tabs>
      {tabData?.map((ele, ind) => {
        return (
          <TabPanel key={ind} value={value} index={ind} className="tabPanel">
            {ele?.map((ele2, ind2) => {
              return (
                <NavLink
                  key={ind2}
                  to={`${
                    heading === "Press Releases"
                      ? "/news-&-research/press-releases/" + ele2?.slug
                      : heading === "Indxx Insights"
                      ? "/news-&-research/news-and-research-insider/" +
                        ele2?.slug
                      : ele2?.URL
                      ? ele2?.URL
                      : heading === "Index Documents"
                      ? ele2?.PDF
                      : ele2?.id && ele2?.PDF && token
                      ? ele2.PDF
                      : ""
                    // heading === "Index Documents"
                    //   ? ele2.PDF
                    //   : heading === "Press Releases"
                    //   ? "/news-&-research/press-releases/" + ele2?.slug
                    //   : heading === "Indxx Insights"
                    //   ? "/news-&-research/news-and-research-insider/" +
                    //     ele2?.slug
                    //   : heading === "News"
                    //   ? ele2?.URL
                    //   : (heading === "Index Notifications" && token) ||
                    //     heading === "Index Documents"
                    //   ? ele2.PDF
                    //   : ""
                  }`}
                  target={
                    // heading === "Press Releases" || heading === "Indxx Insights"
                    //   ? ""
                    //   : heading === "Index Documents" || heading === "News"
                    //   ? "_blank"
                    //   : heading === "Index Notifications" && !token
                    //   ? ""
                    //   : "_blank"
                    heading === "Press Releases" ||
                    heading === "Indxx Insights" 
                    ||
                    (ele2?.id && ele2?.PDF && !token)
                      ? ""
                      : "_blank"
                  }
                  className={`links DF JCSB  ${
                    ele.length - 1 === ind2
                      ? "tabPanelChildLast"
                      : "tabPanelChild"
                  } P1 verySmallMobDIB bGColorSkyBlue`}
                  onClick={() =>
                    ele2?.id ? announcementTrack(ele2?.Title, ele2?.id) : ""
                  }
                >
                  <Box component="span" className="tabPanelTitle text">
                    {ele2.Title}
                  </Box>
                  <Box
                    component="span"
                    className="tabPanelDate verySmallMobFloatRight verySmallMobPL1"
                  >
                    {dateFunction(ele2.Date)}
                  </Box>
                </NavLink>
              );
            })}
          </TabPanel>
        );
      })}
    </Box>
  );
}
